import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BatchService {


    constructor(private http: CustomHttpService) { }

    getAllBatchesWithCount(params: any): Observable<any> {
        return this.http.post(environment.getAllBatchesWithCount, params);
    }

    getAllBatches(params: any): Observable<any> {
        return this.http.post(environment.getAllBatches, params);
    }

    createBatch(data: any): Observable<any> {
        return this.http.post(environment.createBatch, data);
    }

    updateBatch(data: any): Observable<any> {
        return this.http.post(environment.updateBatch, data);
    }

    deleteBatch(data: any): Observable<any> {
        return this.http.post(environment.deleteBatch, data);
    }
}